<div class="saved_chat_content_wrapper">
  <div *ngIf="data.length > 0">
  <div *ngFor="let d of data; let i = index; trackBy: trackBySearchData"> 
    <div class="chat_search_string_wrapper">
      <div class="chat_search_string_container">
        <div class="user_search_wrapper">
          <div class="user_icon_wrapper">
            <ngx-avatar size="50" [src]="userProfile?.picture ? userProfile?.picture : ''" [name]="userProfile?.fullName"
        [textSizeRatio]="2" [round]="true" [initialsSize]="2"></ngx-avatar>
          </div>
          <div class="chat_search_string"> 
            {{d.searchData[i]?.searchTerm}}
          </div>
        </div>
      </div>
    </div>
    <div class="chat_response_wrapper">
      <div class="chat_response_container">
        <div class="engine_response_wrapper">
          <div class="engine_icon_wrapper">
            <img src="assets/images/chatBot-logo.png" alt="logo">
          </div>
          <div *ngIf="d.searchData[i].Type === 'Textual-Answer'" class="chat_response" [innerHTML]="d.searchData[i]?.responseContent">
          </div>
          <div *ngIf="d.searchData[i].Type !== 'Textual-Answer'" class="chat_response">
            {{getItemsForPrint(d.searchData[i].Type)}}
            <div *ngFor="let item of chartItems">
              <div *ngIf="item == 'list'">
                {{generateRandomNumber('',0)}}
                <div id="{{'container_'+RandomNo}}"></div>
                {{ HandleArray(d.searchData[i],RandomNo,item,'') }}
              </div>
              <div *ngIf="item == 'chart'">
                <div *ngIf="d.searchData[i].chartType == 'comparison' || d.searchData[i].chartType == 'bar'">
                  {{generateRandomNumber('',0)}}
                  <div id="{{'container_'+RandomNo}}"></div>
                  {{ HandleArray(d.searchData[i],RandomNo,item,'') }}
                </div>
                <div *ngIf="d.searchData[i].chartType == 'analysis'">
                  {{ HandleArray(d.searchData[i],RandomNo,item,'UniqueName') }}
                  <div *ngFor="let item1 of uniqeNameForCharts; let chatIndex = index">
                    {{ generateRandomNumber('Analysis', chatIndex) }}
                    <div id="{{ 'container_' + randomNumbForCharts[chatIndex] }}"></div>
                    <div *ngIf="(chatIndex+1) == uniqeNameForCharts.length">
                      {{ HandleArray(d.searchData[i],RandomNo,item,'') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div *ngIf="isNewSearch">
    <div class="chat_search_string_wrapper">
      <div class="chat_search_string_container">
        <div class="user_search_wrapper">
          <div class="user_icon_wrapper">
            <img
              src="https://o3storage.blob.core.windows.net/o3-live-attachments/ProfileImage/100003_2022-11-27_20221127T144255438.jpg"
              alt="user_icon">
          </div>
          <div class="chat_search_string">
            {{newSearchData?.searchData[newSearchData?.searchData?.length - 1]?.searchTerm}}
          </div>
        </div>
      </div>
    </div>
    <div class="chat_response_wrapper">
      <div class="chat_response_container">
        <div class="engine_response_wrapper">
          <div class="engine_icon_wrapper">
            <img src="assets/images/chatBot-logo.png" alt="logo">
          </div>
          <div id="new_search_content" class="chat_reponse">
          </div>
        </div>
      </div>
    </div>
  </div>

</div>